module.exports = __webpack_public_path__ + "img/triangle-40.fbf8987c.gif";